import Role from '@/statics/role';
import {
  ADMIN_TOKEN_KEY,
  ADMIN_TOKEN_KEY_IMPERSONATE,
  AUTH_TOKEN_KEY_DEFAULT,
  AUTH_TOKEN_KEY_IMPERSONATE,
  IS_IMPERSONATED,
  REFRESH_TOKEN_KEY_DEFAULT,
  REFRESH_TOKEN_KEY_IMPERSONATE
} from '@/plugins/vue-auth';
import { NAMESPACE } from '@/modules/Authentication/store';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  computed: {
    ...mapState(NAMESPACE, ['adminView']),
    isAdmin() {
      return !!this.$auth.token(ADMIN_TOKEN_KEY);
    },
    hasAdminView() {
      return this.adminView && this.isAdmin;
    },
    role() {
      return Role;
    }
  },

  methods: {
    ...mapActions(['reset']),

    ...mapMutations(NAMESPACE, {
      updateAdminView: 'SET_ADMIN_VIEW',
      setLoadingCurrent: 'SET_LOADING_CURRENT',
      resetLoadingCurrent: 'RESET_LOADING_CURRENT',
      setCurrent: 'SET_CURRENT'
    }),

    setAdminView(enabled) {
      this.updateAdminView(enabled);
      window.localStorage.setItem('dvkmu_admin_view', enabled);
    },

    logout() {
      this.setLoadingCurrent();

      this.$auth
        .logout({
          redirect: '/login'
        })
        .then(() => {
          this.reset();
          this.$auth.token(AUTH_TOKEN_KEY_DEFAULT, null);
          this.$auth.token(REFRESH_TOKEN_KEY_DEFAULT, null);

          if (IS_IMPERSONATED) {
            this.$auth.token(AUTH_TOKEN_KEY_IMPERSONATE, null);
            this.$auth.token(REFRESH_TOKEN_KEY_IMPERSONATE, null);
            this.$auth.token(ADMIN_TOKEN_KEY_IMPERSONATE, null);
          }

          this.resetLoadingCurrent();
        });
    }
  }
};
